var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    _vm.$style.container,
    _vm.isTransparent && _vm.$style['container--transparent'],
    _vm.isSmall && _vm.$style['container--small'],
  ]},[_c('div',{class:_vm.$style.flag},[_c('div',{class:_vm.$style.iconWrapper},[_c('icon',{class:_vm.$style.icon,attrs:{"name":_vm.locale}})],1)]),_c('div',{class:_vm.$style.label},[_vm._v(" "+_vm._s(_vm.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }